<template>
<div class="pagination_container">
  <ul class="pagination">
    <li class="icon">
      <a href="#"><span class="fas fa-angle-left"></span>Previous</a>
    </li>
    <li><a href="#">1</a></li>
    <li><a href="#">2</a></li>
    <li><a href="#">3</a></li>
    <li><a href="#">4</a></li>
    <li class="icon">
      <a href="#">Next<span class="fas fa-angle-right"></span></a>
    </li>
  </ul>
</div>
</template>

<script scoped>
export default {
    name: 'Navigation',
}
</script>